import getProductId from './getCertifiedProductId';

// This utility is used to determine the product to use in certifiedSponsor.json / wordpress cpo endpoint
export default function getCertifiedDataByProductId(certifiedProduct, makeCode, certifieddata) {
  if (certifieddata === void 0) {
    certifieddata = {};
  }
  const productId = getProductId(certifiedProduct, makeCode);
  return certifieddata[productId] ? {
    productId,
    ...certifieddata[productId]
  } : {};
}